module.exports = __webpack_public_path__ + "static/img/wenzhen@3x.4a9ac5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/wenzhen@3x.jpg
// module id = aMHF
// module chunks = 1